export default {
  subscriptionRenewal: {
    packages: {
      title: {
        long: "Select A Package For Renewal",
        short: "Renewal Packages",
      },
    },
    summary: {
      title: "Your Renewal Package",
    },
    subscriptionInfoAlert: {
      title: "Please note:",
      packageExpiryMessage:
        "Your {name} package entitlements will expire on <strong>{date}</strong>",
      currentPackageExpiryMessage:
        "Your current {name} package entitlements will expire on <strong>{date}</strong>",
      renewInAdvanceMessage:
        "Do consider the start date wisely as it cannot be changed upon payment confirmation.",
      newPackageStartDateMessage:
        "Your new subscription {name} package will be activated on <strong>{date}</strong>",
      existingCreditBalanceExpiryMessage:
        "Existing credit balance will expire upon the activation of your new subscription package.",
    },
    button: {
      goBack: "Back",
    },
    package: {
      bestValuePlan: {
        label: "Best Value Plan",
      },
      price: {
        perYear: "/ year",
      },
      button: {
        getPackage: "Get {name}",
      },
      listingProducts: {
        title: "TO GET YOU LISTED",
      },
      analyticProducts: {
        title: "TO KEEP YOU CONNECTED",
      },
      otherProducts: {
        title: "TO HELP YOU WIN",
        brickz: {
          value: "{unit} {period}{unit, plural, =0 {} =1 {} other {s}}",
        },
      },
    },
    termsAndConditions: {
      link: "T&Cs applies",
      priceIncludeTax: "*Total price displayed is inclusive of {percent}% SST",
    },
    renewOption: {
      modal: {
        title:
          "Your subscription is still active, do you want to renew your package on iProperty PRO?",
      },
      renewInAdvance: {
        label: "Renew in advance",
        content:
          "Commence your new subscription package earlier to gain access to your new subscription package credits.",
      },
      renewUponExpiry: {
        label: "Renew upon expiry",
        content:
          "Your account will be automatically renewed with the new subscription when your current subscription package expires.",
      },
    },
    renewInAdvance: {
      modal: {
        title: "Select new package start date",
        okButton: "Save new date",
      },
      dateNotSelectedHint:
        "*You can only select start date not later than your current subscription package end date",
      dateSelectedHint: "This is your new package start date",
    },
    paymentSummary: {
      modal: {
        confirmStartDateMessage:
          "Upon payment completion, the new subscription start date cannot be changed:",
        package: "{name} package",
        startDate: "Start date: {date}",
        endDate: "End date: {date}",
      },
    },
  },
};
